<template>
    <div
        class="VSelect"
        v-click-outside="hideDropdown"
    >
        <div
            class="VSelect-title"
            @click="changeDropdownVisabillity(!isShowDropdown)"
        >
            <slot>
                <template v-if="item">
                    {{ item[showProperty] }}
                </template>
                <template v-else>
                    {{ noSelectedText }}
                </template>
            </slot>
        </div>
        <ul
            class="VSelect-dropdown"
            v-if="isShowDropdown && isShowMenu"
        >
            <li class="VSelect-dropdown__search" v-if="withSearch">
                <input
                    v-model="searchQuery"
                    :placeholder="searchPlaceholder"
                    class="VSelect-search-input"
                    @click.stop
                    @input="filterOptions"
                />
            </li>
            <li
                v-for="(option,optionIndex) in filteredOptions"
                class="VSelect-dropdown__li"
                :class="{'VSelect-dropdown__li_active':(option[showProperty] === item[showProperty]) ||optionIndex === activeIndex }"
                :key="optionIndex"
                @click="chooseItem(option)"
            >
                <img v-if="option[iconProperty]"
                    :src="option[iconProperty]"
                    alt="Painting"
                >
                {{ option[showProperty] }};
            </li>
            <li class="VSelect-dropdown__li_dropdown">
                <slot name="dropdown-bottom"></slot>
            </li>
        </ul>
    
    </div>
</template>

<script>
    import {fixBlockIntersection} from '../helpers/coordinatesHelper';
    
    export default {
        name: 'VSelect',
        model: {
            prop: 'item',
            event: 'updateItem',
        },
        props: {
            title: {
                type: String,
                default: '',
            },
            activeIndex: {
                type: Number,
                default: -1,
            },
            options: {
                type: Array,
                required: true,
                default: () => [],
            },
            item: {
                required: true,
                validator: prop => typeof prop === 'object' || prop == null,
            },
            noSelectedText: {
                type: String,
                default: 'No Selected',
            },
            showProperty: {
                type: String,
                default: 'name',
            },
            iconProperty: {
                type: String,
                default: '',
            },
            isShowMenu: {
                type: Boolean,
                default: true,
            },
            isFixIntersection: {
                type: Boolean,
                default: true,
            },
            withSearch: {
                type: Boolean,
                default: false,
            },
            searchPlaceholder: {
                type: String,
                default: 'Search...',
            },
            searchFields: {
                type: Array,
                default() {
                    return [this.showProperty];
                },
            },
        },
        data() {
            return {
                isShowDropdown: false,
                searchQuery: '',
            };
        },
        computed: {
            filteredOptions() {
                if (!this.withSearch || !this.searchQuery.trim()) {
                    return this.options;
                }
                
                const query = this.searchQuery.toLowerCase().trim();
                return this.options.filter(option => 
                    this.searchFields.some(field => 
                        option[field] && option[field].toString().toLowerCase().includes(query)
                    )
                );
            },
        },
        methods: {
            changeDropdownVisabillity(isShow) {
                this.isShowDropdown = isShow;
                if (isShow) {
                    this.$emit('clickedButton');
                    if (this.isFixIntersection) {
                        this.$nextTick(() => {
                            fixBlockIntersection(this.$el.querySelector('.VSelect-dropdown'), {bottom: 50});
                        });
                    }
                } else {
                    this.searchQuery = '';
                }
                this.$emit('showDropDown', isShow);
            },
            chooseItem(item) {
                this.changeDropdownVisabillity(false);
                this.$emit('updateItem', item);
            },
            hideDropdown() {
                if (this.isShowDropdown) {
                    this.isShowDropdown = false;
                    this.searchQuery = '';
                    this.$emit('closed');
                }
            },
            filterOptions() {
                // Method for filtering options
            },
        },
    };

</script>

<style
    scoped
    lang="scss"
>
    .VSelect {
        position: relative;
        
        &-title {
            display: flex;
            background: #FFFFFF;
            border-radius: 10px;
        }
        
        &-search-input {
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
            padding: 6px 10px;
            border: 1px solid #e0e0e0;
            border-radius: 4px;
            font-size: 12px;
            outline: none;
            
            &:focus {
                border-color: $primary-color;
            }
        }
        
        &-dropdown {
            position: absolute;
            max-height: 350px;
            z-index: $dropdown-z-index;
            background: #FFFFFF;
            overflow: auto;
            border-radius: 5px;
            //border-bottom: 10px solid #FFFFFF;
            width: 100%;
            min-width: 160px;
            @include scrollbar-styles;
            @include default-shadow;
            
            &__search {
                list-style-type: none;
                padding: 8px 12px;
                border-bottom: 1px solid #e0e0e0;
                background: #f8f9fa;
                box-sizing: border-box;
                
                input {
                    width: 100%;
                    max-width: 100%;
                    box-sizing: border-box;
                }
            }
            
            &__li {
                list-style-type: none;
                display: flex;
                align-items: center;
                cursor: pointer;
                padding: 6px 15px;
                
                &:hover {
                    background: $primary-color;
                    color: #FFFFFF !important;
                }
                
                &_active {
                    background: $secondary-color;
                    color: #FFFFFF;
                }
                
                &_dropdown {
                    padding: 6px 15px;
                    list-style-type: none;
                    display: flex;
                    align-items: center;
                }
            }
            
        }
    }

</style>
